export type DocumentStateSeverity = 'secondary' | 'info' | 'warning' | 'success' | 'danger';

/** Tint of a produced document's state chip; the text shown is the server's own `state.label`. */
const SEVERITY_BY_STATE_VALUE: Readonly<Record<string, DocumentStateSeverity>> = Object.freeze({
	pending: 'secondary',
	waiting: 'secondary',
	running: 'info',
	failed: 'danger',
	skipped: 'secondary',
	to_review: 'warning',
	verified: 'success',
});

/** An unrecognized state falls back to the neutral tint rather than throwing. */
const resolveDocumentStateSeverity = (stateValue: string): DocumentStateSeverity =>
	SEVERITY_BY_STATE_VALUE[stateValue] ?? 'secondary';

export default resolveDocumentStateSeverity;
